import React from 'react'
import Label from '../ui/label/Label'
import TimePickerComponent from '../ui/inputs/timePicker/TimePicker'
import ValidationText from '../ui/validation/ValidationText'

const FormTimePickerField = ({
    dataField,
    labelName,
    name,
    keyId,
    value,
    error,
    formSetting,
    overRideProps,
    isRequired,
    fieldSetting,
    onChange,
    onBlure,
    onActionChange,
    ...otherProps
}) => {
    return (
        <div className="date-picker-label-part">
            <div className="input-label-part">
                {labelName && (
                    <Label labelName={labelName} isRequired={isRequired} />
                )}
            </div>
            <div className={`input-date-sec custom-time-picker`}>
                <TimePickerComponent
                    label={labelName}
                    id={name}
                    keyId={keyId}
                    value={value}
                    name={name}
                    disableClock={true}
                    onChange={(value) => onChange(dataField, value)}
                    clearIcon="❌"
                    clockIcon="🕒"
                    // maxTime="22:00"
                    // minTime="08:00"
                    hourPlaceholder="HH"
                    minutePlaceholder="MM"
                    className="custom-time-picker"
                    {...otherProps}
                />

                <ValidationText error={error || ""} />
            </div>
        </div>
    )
}

export default FormTimePickerField